export default __webpack_public_path__ + "static/media/anton.3a7bf18b.jpg";